import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
/**
 * Context to provide inherited value for empty column handling
 */
const EmptyColumnHandlingInheritedContext = createContext("includeEmpty");
EmptyColumnHandlingInheritedContext.displayName =
    "EmptyColumnHandlingInheritedContext";
export function EmptyColumnHandlingProvider(props) {
    const { emptyColumnHandling, children } = props;
    const inheritedValue = useContext(EmptyColumnHandlingInheritedContext);
    const value = emptyColumnHandling !== null && emptyColumnHandling !== void 0 ? emptyColumnHandling : inheritedValue;
    return (_jsx(EmptyColumnHandlingInheritedContext.Provider, { value: value, children: children }));
}
export function useEmptyColumnHandling(localValue) {
    const inheritedValue = useContext(EmptyColumnHandlingInheritedContext);
    return localValue !== null && localValue !== void 0 ? localValue : inheritedValue;
}
//# sourceMappingURL=EmptyColumnHandlingProvider.js.map